import { render, staticRenderFns } from "./QuestionPhoto.vue?vue&type=template&id=691e32cc&"
import script from "./QuestionPhoto.vue?vue&type=script&lang=js&"
export * from "./QuestionPhoto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports